import { createFileRoute } from "@tanstack/react-router";
import React from "react";

import { z } from "zod";

const gratitudeSearchSchema = z.object({
  program_id: z.string().optional(),
  donation_id: z.string().optional(),
  currency: z.string().optional(),
  response_message: z.string().optional(),
  points_total: z.number().optional(),
  points_added_success: z.coerce.boolean().optional(),
  points_circle_id: z.string().optional(),
});

export const Route = createFileRoute("/$lang/gratitude/$programId")({
  component: React.lazy(() =>
    import("@/pages/gratitude").then((mod) => ({
      default: mod.Gratitude,
    })),
  ),
  validateSearch: (search) => gratitudeSearchSchema.parse(search),
});
